<div class="registaration">
    <div class="r-header">
        <img src="assets/images/logo-dark.svg" alt="">
    </div>
    <div class="sidebar">
        <img src="assets/images/logo2.svg" class="logo" alt="">
        <h2>
            We send the OTP to your email for verifyingdddddddddd
        </h2>
        <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
    </div>
    <div class="form-body">
        <div class="cant-have-account">
            <a [href]="baseUrl" class="back-to-home">
                <i class="fa-solid fa-arrow-left"></i>
                <span>Go to Home</span>
            </a>
            <div class="account">
                <span>
                    Don’t have an account?
                </span>
                <a [routerLink]="'/auth/signup'">
                    Sign up
                </a>
            </div>
        </div>

        <div class="form-card">
            <div class="open-otp">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M36.75 9.1875L21 23.625L5.25 9.1875" stroke="url(#paint0_linear_4317_45425)"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M5.25 9.1875H36.75V31.5C36.75 31.8481 36.6117 32.1819 36.3656 32.4281C36.1194 32.6742 35.7856 32.8125 35.4375 32.8125H6.5625C6.2144 32.8125 5.88056 32.6742 5.63442 32.4281C5.38828 32.1819 5.25 31.8481 5.25 31.5V9.1875Z"
                        stroke="url(#paint1_linear_4317_45425)" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M18.1381 21L5.65625 32.4417" stroke="url(#paint2_linear_4317_45425)" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M36.3452 32.4417L23.8633 21" stroke="url(#paint3_linear_4317_45425)" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <defs>
                        <linearGradient id="paint0_linear_4317_45425" x1="5.25" y1="16.4052" x2="36.7537" y2="16.4052"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5304FB" />
                            <stop offset="0.86" stop-color="#8F67FD" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_4317_45425" x1="5.25" y1="20.9982" x2="36.7537" y2="20.9982"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5304FB" />
                            <stop offset="0.86" stop-color="#8F67FD" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_4317_45425" x1="5.65625" y1="26.72" x2="18.1396" y2="26.72"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5304FB" />
                            <stop offset="0.86" stop-color="#8F67FD" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_4317_45425" x1="23.8633" y1="26.72" x2="36.3466" y2="26.72"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.86" stop-color="#8F67FD" />
                        </linearGradient>
                    </defs>
                </svg>

                <p>We send the OTP to your email for verifying</p>
            </div>
            <button (click)="handleOpt()" class="btn btn-primary btn-md w-100">Open OTP</button>
        </div>
        <div></div>
    </div>
</div>